import type {
    IConfComponents,
    IFormComponent
  } from '@/modules/Administracion/interfaces'

export const mapComponentToFormComponent = (component: IConfComponents, padre?: string | null ) : IFormComponent => {
    let components = [] as IFormComponent[]
    if(component.components){
        components = component.components.map((c: IConfComponents) => { return mapComponentToFormComponent(c, component.name as string) }) as IFormComponent[]
    }
    const newComp = {
        ...component,
        componentId: padre,
        components
    } as IFormComponent
  return newComp
}
export const getFieldsFromTabs = <T,A>(tabs: T[], fieldName: string) => {
    const campos = [] as A[]
    if (!tabs || !Array.isArray(tabs) || tabs.length === 0) {
      return { camposTab: [], campos: [], camposComponent: [] }
  }
  for (const element of tabs) {
    for (const itemC of element['components'] as A[]) {
        if((itemC as object)['component']){
            (itemC as object)['component']['tab'] = element[fieldName];
            if((itemC as object)['component']['typeComponent'] == 'SECTION' && (itemC as object)['component']['multi'] && (itemC as object)['component']['name'].indexOf('_ITEM_') == -1){
              // Se conserva el nombre original en una variable en vez de
              // recuperarlo con replace('_ITEM_1',''), que reemplaza la primera
              // ocurrencia y es frágil.
              const nombreOriginal = (itemC as object)['component']['name'];
              (itemC as object)['component']['name'] = `${nombreOriginal}_ITEM_1`;
              (itemC as object)['component']['item'] = 1;
              element['components'].forEach(item => {
                if(item.component.componentId == nombreOriginal){
                  item.component.componentId = (itemC as object)['component']['name']
                  // Misma guardia que el backend (mapInitTabComponetsForm): sin
                  // ella un hijo ya sufijado terminaba como X_ITEM_1_ITEM_1 y
                  // dejaba de casar con su sección.
                  item.component.name = item.component.name.indexOf('_ITEM_') === -1
                    ? `${item.component.name}_ITEM_1`
                    : item.component.name;
                }
              })
            }
            (itemC as object)['component']['value'] = (itemC as object)['citcValue'] || (itemC as object)['component']['value'] || (itemC as object)['component']['defaultValue'];
            (itemC as object)['component']['searchValue'] = (itemC as object)['citcSearchValue'] || null;
        }
        campos.push(itemC)
      }
    }
    campos.sort((a, b) => ((a as object)['component']['orderValue'] || 0) - ((b as object)['component']['orderValue'] || 0))
    const camposComponent = campos.map(item => (item as object)['component']) as IConfComponents[]
    const camposTab = tabs.map(item => (item as object)['components'] as A[]).flat() as A[]
    return { camposTab, campos, camposComponent }
}
